import { useState } from "react";
import { toast } from "sonner";
import { Copy, Check, MessageCircle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { CONTACT, waLink } from "@/data/site";

export const ZelleCheckout = ({ plan, price, highlighted }) => {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT.zelleEmail);
      setCopied(true);
      toast.success("Correo de Zelle copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("No se pudo copiar. Cópialo manualmente.");
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          data-testid={`pay-zelle-trigger-${plan}`}
          className={`mt-2 inline-flex items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition-all duration-200 active:scale-95 border ${
            highlighted
              ? "border-[#6d1ed4]/50 text-[#a06bff] hover:bg-[#6d1ed4] hover:text-white"
              : "border-white/15 text-white hover:bg-white/5"
          }`}
        >
          <span className="font-bold text-[#a06bff]">Z</span> Pagar con Zelle
        </button>
      </DialogTrigger>
      <DialogContent className="bg-bp-surface2 border-bp-border text-white sm:max-w-md" data-testid="zelle-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">
            Pagar con Zelle — <span className="text-bp-primary">${price} USD</span>
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-sm text-[#A3A3A3]">
            Envía <strong className="text-white">${price} USD</strong> por Zelle a los siguientes datos y luego mándanos el comprobante por WhatsApp para activar tu <strong className="text-white">Plan {plan}</strong>.
          </p>

          <div className="rounded-xl border border-bp-border bg-bp-surface p-4 space-y-3">
            <div>
              <div className="text-[11px] uppercase tracking-[0.15em] text-[#737373]">Correo Zelle</div>
              <div className="flex items-center justify-between gap-3 mt-1">
                <span className="text-white font-medium text-sm break-all">{CONTACT.zelleEmail}</span>
                <button
                  onClick={copyEmail}
                  data-testid="zelle-copy-email"
                  className="shrink-0 inline-flex items-center gap-1 rounded-lg border border-white/15 px-2.5 py-1.5 text-xs text-white hover:bg-white/5 transition-colors"
                >
                  {copied ? <Check className="w-3.5 h-3.5 text-[#25D366]" /> : <Copy className="w-3.5 h-3.5" />}
                  {copied ? "Copiado" : "Copiar"}
                </button>
              </div>
            </div>
            <div className="border-t border-bp-border pt-3">
              <div className="text-[11px] uppercase tracking-[0.15em] text-[#737373]">Titular</div>
              <div className="text-white font-medium text-sm mt-1">{CONTACT.zelleName}</div>
            </div>
          </div>

          <ol className="text-sm text-[#A3A3A3] space-y-1.5 list-decimal list-inside">
            <li>Abre tu app bancaria y entra a Zelle.</li>
            <li>Envía <strong className="text-white">${price} USD</strong> al correo de arriba.</li>
            <li>Envíanos el comprobante por WhatsApp y activamos tu acceso.</li>
          </ol>

          <a
            href={waLink(`Hola, acabo de pagar el Plan ${plan} ($${price} USD) por Zelle. Adjunto mi comprobante.`)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="zelle-whatsapp"
            className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-black transition-all duration-200 hover:bg-[#1ebe5a] active:scale-95"
          >
            <MessageCircle className="w-4 h-4" /> Enviar comprobante por WhatsApp
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
